<template>
  <div class="galton-board-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>二项分布 → 正态分布</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Pegs -->
          <circle v-for="p in pegs" :key="p.id" :cx="p.x" :cy="p.y" r="2" fill="#888" />
          
          <!-- Falling Balls -->
          <circle v-for="b in balls" :key="b.id" :cx="b.x" :cy="b.y" r="3" :fill="b.color" opacity="0.8" />

          <!-- Bins (Distribution) -->
          <g transform="translate(100, 220)">
             <rect v-for="(count, i) in bins" :key="i" :x="i*25" :y="-count*5" width="20" :height="count*5" fill="rgba(0, 210, 255, 0.4)" stroke="#00d2ff" />
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>统计结果：趋于正态分布 (钟形曲线)</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-button type="primary" size="mini" @click="dropBalls">批量投放小球</el-button>
             <el-button size="mini" @click="reset">清空统计</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>高尔顿钉板是演示**中心极限定理**的经典教具。当大量球从顶部落下，每次遇到钉子都会以50%概率向左或向右弹跳。这些独立的随机过程叠加后，小球在底部容器中的分布会呈现完美的**正态分布**。这一原理解释了为什么许多宏观物理量（如气体分子动能）虽由微观随机事件构成，却具有确定的统计特性。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GaltonBoardViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      pegs: [],
      balls: [],
      bins: Array(9).fill(0),
      timer: null
    }
  },
  created() {
     // Generate Pegs
     for (let row = 0; row < 6; row++) {
        let count = row + 1;
        let startX = 200 - (row * 12.5);
        for (let j = 0; j < count; j++) {
           this.pegs.push({ id: `p-${row}-${j}`, x: startX + j*25, y: 40 + row*25 });
        }
     }
  },
  methods: {
    dropBalls() {
       for (let i = 0; i < 20; i++) {
          setTimeout(() => {
             this.balls.push({
                id: Date.now() + i,
                x: 200,
                y: 10,
                vx: 0,
                vy: 0,
                row: -1,
                color: `hsl(${Math.random()*360}, 70%, 60%)`
             });
          }, i * 100);
       }
       if (!this.timer) this.update();
    },
    update() {
       this.balls.forEach((b, idx) => {
          b.y += 2;
          // Check collision with rows
          let currentRow = Math.floor((b.y - 40) / 25);
          if (currentRow > b.row && currentRow < 6) {
             b.row = currentRow;
             b.x += (Math.random() > 0.5 ? 12.5 : -12.5);
          }
          // End of movement
          if (b.y > 210) {
             let binIdx = Math.floor((b.x - 100) / 25);
             if (binIdx >= 0 && binIdx < 9) {
                this.bins[binIdx]++;
                this.bins = [...this.bins];
             }
             this.balls.splice(idx, 1);
          }
       });
       if (this.balls.length > 0) {
          this.timer = requestAnimationFrame(this.update);
       } else {
          this.timer = null;
       }
    },
    reset() {
       this.bins = Array(9).fill(0);
       this.balls = [];
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
.galton-board-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
